import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { SettingsProvider } from "../../contexts/SettingsContext";
import { NavigationProvider } from "../../contexts/NavigationContext";
import { TourProvider } from "../../contexts/TourContext";
import TourOverlay from "../tour/TourOverlay";

const DashboardLayout = ({
  menuList,
  navigatePath,
  activationDetails,
  children,
}) => {
  return (
    <SettingsProvider>
      <NavigationProvider>
        <TourProvider isStripeDone={activationDetails?.isStripeDone}>
          <div className="sidebar-page-wrapper">
            <Sidebar menuList={menuList} isClickable activation={activationDetails} />
            <div id="dashboard">
              <Navbar
                navigateBack={navigatePath}
                activationDetails={activationDetails}
              />
              <>{children}</>
            </div>
          </div>
          <TourOverlay />
        </TourProvider>
      </NavigationProvider>
    </SettingsProvider>
  );
};

export default DashboardLayout;
